import React, {useEffect, useState} from 'react'
import { useRef } from 'react'
import {set, useForm} from 'react-hook-form'
import {
  useOrgSettings,
  useOrgSettingsTwilio,
  useOrgSettingsGEM,
  useResetTwilio,
  useResetGEM
} from '../../mutations/useOrgSettings'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton
} from '@material-ui/core'
import {Delete, Edit, ExpandMore} from '@material-ui/icons'
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';

import HookForm from '../../components/common/HookForm'
import TextInput from '../../components/common/inputs/TextInput'
import { useAuthToken } from '../../slices/authSlice'
import styles from './OrgSettingsPage.module.css'
import UsersTable from './UsersTable'
import { useFetchOrgSettings } from './useFetchOrgSettings'
import { useFetchOrgSettingsTwilio } from './useFetchOrgSettingsTwilio'
import {useFetchOrgSettingsGEM, useFetchOrgSettingsStripe} from './useFetchOrgSettingsGEM'
import MaskedInput from "../../components/common/inputs/MaskedInput";
import {emailRegex, phoneRegex, zipCodeRegex} from "../../util/formValidation";
import {useDispatch} from "react-redux";
import {useParams} from "react-router";
import {EventState, setEvent} from "../../slices/eventSlice";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import {OrgState, setOrg} from "../../slices/orgSlice";
import DateTimeInput from "../../components/common/inputs/DateTimeInput";
import {Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Stack} from "@mui/material";
import {useQueryClient} from "react-query";
import axios from "axios";
import {
  DataGridPremium, GridCellParams,
  GridColDef,
  GridToolbarContainer, GridValueFormatterParams,
} from "@mui/x-data-grid-premium";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import StripeForm from "./StripeForm";

type FormData = {
  email: string
  phone: string
  postalcode: string
  orgInfo: {
    name: string
    contactname: string
    address1: string
    address2: string
    city: string
    state: string
    postalcode: string
    email: string
    phone: string
  }
}

type formDataTwilio = {
  twiliophone: string
  twilioaccountsid: string
  twilioauthtoken: string
  valid: boolean
  twiliovisauctionsnapaccount: boolean
}

type formDataGEM = {
  transactionid: string
  gatewayid: string
  ecommerceid: string
  retailid: string
  lastupdated: string
  validationdate: string
}

interface Params {
  id: string,
  name: string
  refreshaccountid: string
  accountid: string
}

const OrgSettingsPage = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const { id, name, refreshaccountid, accountid } = useParams<Params>()
  const eventState: EventState = {
    eventId: id,
    eventName: name
  }
  dispatch(setEvent(eventState))
  var rows = []

  const putOrgSetting = useOrgSettings()
  const putOrgSettingsTwilio = useOrgSettingsTwilio();
  const putOrgSettingsGEM = useOrgSettingsGEM();
  const [dialogMsg, setDialogMsg] = React.useState("")
  const [stripeData, setStripeData] = React.useState([])
  const [dialogObj, setDialogObj] = React.useState({ msg: "", show: false, twilio: false })
  const [deleteDialogObj, setDeleteDialogObj] = React.useState({ msg: "", id: 0 })
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [stripeAccordionExpanded, setstripeAccordionExpanded] = React.useState<boolean>(false)

  const [stripeAccountData, setStripeAccountData] = React.useState({id: 0, stripeaccountid: '', stripeaccountname: ''})

  const formMethods = useForm<FormData>()
  const { reset } = formMethods

  const twilioFormMethods = useForm<formDataTwilio>()
  const { reset : twilloReset } = twilioFormMethods

  const gemFormMethods = useForm<formDataGEM>()
  const { reset : gemReset } = gemFormMethods

  const authToken = useAuthToken()

  useEffect(() => {
    if (accountid || refreshaccountid) {
      setstripeAccordionExpanded(true)

    }
    else {
      setstripeAccordionExpanded(false)
    }
  }, [])


  useEffect(() => {

    const refreshStripeId = async () => {
      const { data } = await axios.post('/striperefresh', {"stripeaccountid": refreshaccountid})
      const parsedData = JSON.parse(data.jsonString)
      if (parsedData?.redirecturl?.length > 0) {
        window.location.href = parsedData.redirecturl
      }
    }
    refreshStripeId()
  }, [refreshaccountid])

  useEffect(() => {
    const refreshStripeId = async () => {
      const { data } = await axios.post('/stripereturn', {"stripeaccountid": accountid})
      const parsedData = JSON.parse(data.jsonString)
      // setStripeAccountData(parsedData)
    }
    refreshStripeId()


  }, [accountid])

  const ontwilioSubmit = async (formData: formDataTwilio) => {
    setIsLoading(true)
    var finaldata = {
      "twiliophone": formData.twiliophone,
      "twilioaccountsid": formData.twilioaccountsid,
      "twilioauthtoken": formData.twilioauthtoken,
    }

    const { data: response } = await putOrgSettingsTwilio.mutateAsync({
      ...finaldata
    })
    const parsedResponse = JSON.parse(response?.jsonString)
    const twilio = JSON.parse(parsedResponse?.twilio)

    if (parsedResponse?.status === 'success' && twilio.valid) {
      const orgState: OrgState = {
        name: settings?.name, message: settings?.message, isdonorsnapcustomer: settings?.isdonorsnapcustomer, twilio: twilio
      }
      dispatch(setOrg(orgState))
      queryClient.invalidateQueries(['orgsettings', authToken?.userid])
      setDialogMsg('Twilio settings successfully saved.')
    }
    if (!twilio.valid) {
      setDialogMsg(twilio.errormessage)
    }
    else if (parsedResponse?.status === 'failure') {
      setDialogMsg(parsedResponse?.message)
    }

    setIsLoading(false)
  }

  const onGEMSubmit = async (formData: formDataGEM) => {
    setIsLoading(true)
    var finaldata = {
      "goetransactionid": formData.transactionid,
      "goegatewayid": formData.gatewayid
    }

    const { data: response } = await putOrgSettingsGEM.mutateAsync({
      ...finaldata
    })
    const parsedResponse = JSON.parse(response?.jsonString)
    if (parsedResponse?.status === 'failure') {
      setDialogMsg(parsedResponse?.message)
    }
    if (parsedResponse?.goemerchant) {
      const goemerchant = JSON.parse(parsedResponse?.goemerchant)
      if (!goemerchant.valid) {
        setDialogMsg(goemerchant.errormessage)
      }
      else if (parsedResponse?.status === 'success' && goemerchant.valid) {
        setDialogMsg('GoEmerchant settings successfully saved.')
      }
    }

    setIsLoading(false)
  }

  const onSubmit = async (formData: FormData) => {
    setIsLoading(true)
    var finaldata = {
      "name": formData.orgInfo.name,
      "contactname": formData.orgInfo.contactname,
      "address" : formData.orgInfo.address1,
      "address2": formData.orgInfo.address2,
      "city": formData.orgInfo.city,
      "state": formData.orgInfo.state,
      "zip": formData.postalcode,
      "email": formData.email,
      "phone": formData.phone
    }

    const { data: response } = await putOrgSetting.mutateAsync({
      ...finaldata
    })
    const parsedResponse = JSON.parse(response?.jsonString)
    if (parsedResponse?.status === 'success') {
      // const orgState: OrgState = {
      //   name: formData.orgInfo.name, message: settings?.message
      // }
      // dispatch(setOrg(orgState))
      setDialogMsg('Organization settings successfully saved.')
    }
    if (parsedResponse?.status === 'failure') {
      setDialogMsg(parsedResponse?.message)
    }
    setIsLoading(false)
  }

  const { data: settings } = useFetchOrgSettings({ userid: authToken?.userid })
  const { data: twilioSettings } = useFetchOrgSettingsTwilio({})
  const { data: GEMSettings } = useFetchOrgSettingsGEM({})
  const { data: stripeSettings } = useFetchOrgSettingsStripe({})

  useEffect(() => {
    if (settings) {
      const orgState: OrgState = {
        name: settings?.name, message: settings?.message, isdonorsnapcustomer: settings?.isdonorsnapcustomer, twilio: settings?.twilio
      }
      dispatch(setOrg(orgState))
    }
  }, [settings])

  useEffect(() => {
    console.log(stripeSettings)
    if (stripeSettings && stripeSettings?.stripelist) {
      const newData = stripeSettings?.stripelist?.map((stripeData) => {
        return {id: stripeData.stripeid, ...stripeData}
      })
      setStripeData(newData)
    }

  }, [stripeSettings])

  const hasInitiatedForm = useRef(false)
  useEffect(() => {
    if (settings && !hasInitiatedForm.current) {
      reset({
        email: settings.email,
        phone: settings.phone,
        postalcode: settings.zip,
        orgInfo: {
          name: settings.name,
          contactname: settings.contactname,
          address1: settings.address,
          address2: settings.address2,
          city: settings.city,
          state: settings.state,
          postalcode: settings.zip,
          email: settings.email,
          phone: settings.phone
        }
      })
      hasInitiatedForm.current = true
    }
  }, [settings])

  const hasInitiatedTwilioForm = useRef(false)
  useEffect(() => {
    if (twilioSettings && !hasInitiatedTwilioForm.current) {
      twilloReset({
          twiliophone: twilioSettings.twiliophone.replace("+1", ""),
          twilioaccountsid: twilioSettings.twilioaccountsid,
          twilioauthtoken: twilioSettings.twilioauthtoken,
          twiliovisauctionsnapaccount: twilioSettings?.twiliovisauctionsnapaccount
      })
      hasInitiatedTwilioForm.current = true
    }
  }, [twilioSettings])

  const hasInitiatedGEMForm = useRef(false)
  useEffect(() => {
    if (GEMSettings && !hasInitiatedGEMForm.current) {
      gemReset({
        transactionid: GEMSettings.transactionid,
        gatewayid: GEMSettings.gatewayid,
        ecommerceid: GEMSettings.ecommerceid,
        retailid: GEMSettings.retailid,
        lastupdated: GEMSettings.lastupdated,
        validationdate: GEMSettings.validationdate
      })
      hasInitiatedGEMForm.current = true
    }
  }, [GEMSettings])

  const columns: GridColDef[] = [
    {
      field: 'Edit',
      disableExport: true,
      // renderHeader: () => {
      //   return (
      //       <IconButton
      //           className={styles.submitButton}
      //           onClick={() => handleAdd()}
      //           size="small">
      //         <Add />
      //       </IconButton>
      //   )
      // },
      width: 80,
      sortable: false,
      renderCell: (params) => (
          <IconButton hidden={!params.row.canedit} className={styles.button} onClick={() => { handleEdit(params) }}>
            <Edit />
          </IconButton>
      )
    },
    {
      field: 'stripeaccountid',
      type: 'string',
      headerName: 'Account Id',
      minWidth: 320
    },
    {
      field: 'stripeaccountname',
      type: 'string',
      headerName: 'Account Name',
      minWidth: 320
    },
    {
      field: 'stripeisvalid',
      type: 'string',
      headerName: 'Is Valid',
      minWidth: 120
    },
    {
      field: 'stripevalidationdate',
      type: 'string',
      headerName: 'Validation Date',
      align: "right",
      minWidth: 180,
      valueFormatter: (params: GridValueFormatterParams) => {
        return (params?.value?.length > 0 ? dayjs(params.value as string).format('MM/DD/YYYY hh:mm A') : '')
      },
    },
    {
      field: 'other',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      disableExport: true,
      width: 220,
      sortable: false,
      renderCell: (params) => {
        return (
            <div>
              {params.row.canvalidate &&
                  <Button
                      variant="contained"
                      size="small"
                      style={{marginRight: '10px'}}
                      onClick={() => {handleValidate(params.row)}}
                      // startIcon={<AddIcon />}
                      color="primary">
                    Validate
                  </Button>
              }
              {params.row.cansetup &&
                  <Button
                      variant="contained"
                      size="small"
                      onClick={() => {handleSetup(params.row)}}
                      // startIcon={<AddIcon />}
                      color="primary">
                    Finish Setup
                  </Button>
              }
            </div>
        )
      }
    },
    {
      field: 'action',
      headerName: 'Delete',
      headerAlign: 'center',
      align: 'center',
      disableExport: true,
      width: 70,
      sortable: false,
      renderCell: (params) => {
        return (
            <div>
              {params.row.candelete &&
                  <IconButton
                      className={styles.button}
                      onClick={() => {
                        handleDelete(params)
                      }}
                  >
                    <Delete/>
                  </IconButton>
              }
            </div>
        )
      }
    }
  ]

  const handleAdd = async () => {
    setIsLoading(true)
    const { data } = await axios.get('/stripenewaccount')
    const parsedData = JSON.parse(data.jsonString)
    if (parsedData?.redirecturl?.length > 0) {
      window.location.href = parsedData.redirecturl
    }
    setIsLoading(false)
  }

  const handleSetup = async (row) => {
    setIsLoading(true)
    const { data } = await axios.post('/stripesetup', {"stripeid": row.id})
    const parsedData = JSON.parse(data.jsonString)
    if (parsedData?.redirecturl?.length > 0) {
      window.location.href = parsedData.redirecturl
    }
    setIsLoading(false)
  }

  const handleValidate = async (row) => {
    const { data } = await axios.post('/stripevalidate', {"stripeid": row.stripeid})
    const parsedData = JSON.parse(data.jsonString)
    if (parsedData?.message && parsedData?.message?.length > 0) {
      setDialogMsg(parsedData.message)
    }
    // else {
    //   const stripeList = parsedData.stripelist
    //   setStripeData(stripeList)
    // }
    queryClient.invalidateQueries(['stripesettings'])
  }

  const deleteDialog = async () => {
    await handleDeleteConfirm(deleteDialogObj.id)
  }

  const handleDelete = (params: GridCellParams) => {
    const message = params.row.stripeaccountname?.length > 0 ? params.row.stripeaccountname : params.row.stripeaccountid
    setDeleteDialogObj({
      msg: 'Are you sure you want to delete \"' + message + "\"?",
      id: Number(params.row.id)
    })
  }

  const handleDeleteConfirm = async (id: number) => {
    var finaldata = {
      "stripeid": id
    }

    const { data } = await axios.delete('/stripe', {data: finaldata})
    const json = JSON.parse(data.jsonString)

    if (json.status === "failure") {
      setDeleteDialogObj({
        msg: '',
        id: 0
      })
      setDialogMsg(json.message)
    }
    else {
      queryClient.invalidateQueries(['stripesettings'])
      setDeleteDialogObj({
        msg: '',
        id: 0
      })
    }
  }

  const handleEdit = (params: GridCellParams) => {
    setStripeAccountData({id: params.row.id, stripeaccountname: params.row.stripeaccountname, stripeaccountid: params.row.stripeaccountid})
    setIsOpen(true)
  }

  function CustomGridToolbar() {
    return (
        <>
          <GridToolbarContainer >
            <>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-begin"
                  alignItems="center"
                  // border={2}
                  xs={3} sm={4} md={4}
              >
                <Grid item xs={10}>
                  <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => {handleAdd()}}
                        startIcon={<AddIcon />}
                        color="primary">
                      Add New Stripe Account
                    </Button>
                  </InputLabel>
                </Grid>
              </Grid>
            </>
          </GridToolbarContainer>
        </>
    )
  }


  const closeDialog = () => {
    setDeleteDialogObj({
      msg: '',
      id: 0
    })
    setDialogMsg('')
    setDialogObj({
      msg: '',
      show: false,
      twilio: false
    })
  }

  const checkPhoneNumber = (value: string) =>
    value?.replace(/\D/g,'').length === 10 || 'Please enter a valid phone number.'

  const onResetGEM = () => {
    setDialogObj({
      msg: 'Are you sure you want to reset the GoEmerchant settings?',
      show: true,
      twilio: false
    })
  }

  const onResetTWILIO = () => {
    setDialogObj({
      msg: 'Are you sure you want to reset the Twilio settings?',
      show: true,
      twilio: true
    })
  }

  const resetConfirm = async () => {
    if (dialogObj.twilio) {
      const { data } = await axios.get('/resettwilio')
      const parsedData = JSON.parse(data.jsonString)
      queryClient.invalidateQueries(['orgsettingstwilio'])
      queryClient.invalidateQueries(['orgsettings', authToken?.userid])
      if (parsedData.status === 'success') {
        const orgState: OrgState = {
          name: settings?.name, message: settings?.message, isdonorsnapcustomer: settings?.isdonorsnapcustomer,
          twilio: { twiliophone:"", twilioaccountsid:"", twilioauthtoken:"",
            valid:false, errormessage:"", validationdate:null}
        }
        dispatch(setOrg(orgState))
        twilloReset({
          twiliophone: "",
          twilioaccountsid: "",
          twilioauthtoken: "",
        })
        setDialogObj({
          msg: "",
          show: false,
          twilio: true
        })
      }
      else {
        setDialogObj({
          msg: parsedData.message,
          show: true,
          twilio: true
        })
      }
    }
    else {
      const { data } = await axios.get('/resetgem')
      const parsedData = JSON.parse(data.jsonString)
      queryClient.invalidateQueries(['orgsettingsgem'])
      if (parsedData.status === 'success') {
        gemReset({
          transactionid: "",
          gatewayid: "",
          ecommerceid: "",
          retailid: "",
          lastupdated: null,
          validationdate: null
        })
        setDialogObj({
          msg: "",
          show: false,
          twilio: true
        })
      }
      else {
        setDialogObj({
          msg: parsedData.message,
          show: true,
          twilio: true
        })
      }
    }
  }

  return (
    <div className={styles.root}>
      <h1>Organization Settings</h1>
        <LoadingBackdrop open={isLoading} />
        <StripeForm isOpen={isOpen} setIsOpen={setIsOpen} stripeAccountData={stripeAccountData}/>
      <>
        <Dialog
            open={deleteDialogObj?.msg?.length > 0}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {deleteDialogObj.msg}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog}>Cancel</Button>
            <Button onClick={deleteDialog}>DELETE</Button>
          </DialogActions>
        </Dialog>
      </>
        <>
          <Dialog
              open={dialogObj?.msg?.length > 0}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {dialogObj.msg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>Cancel</Button>
              <Button onClick={resetConfirm}>RESET</Button>
            </DialogActions>
          </Dialog>
        </>
        <>
          <Dialog
              open={dialogMsg?.length > 0}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {dialogMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>Ok</Button>
            </DialogActions>
          </Dialog>
        </>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
            <h2>Organization Info</h2>
          </AccordionSummary>
          <AccordionDetails>
            <HookForm methods={formMethods}
                      onSubmit={onSubmit}
                      key={9}
                      className={styles.inputsContainer}
                      formProps={{ id: 'org-form-9', name: "9" }}>
            <div className={styles.inputsContainer}>
              <TextInput name="orgInfo.name" label="Organization Name" required/>
              <TextInput name="orgInfo.contactname" label="Contact Name" required/>
              <TextInput name="orgInfo.address1" label="Address Line 1" required/>
              <TextInput name="orgInfo.address2" label="Address Line 2" />
              <TextInput name="orgInfo.city" label="City" required/>
              <TextInput name="orgInfo.state" label="State" required/>
              <TextInput
                  name="postalcode"
                  label="Postal Code"
                  required
                  rules={{
                    pattern: {
                      value: zipCodeRegex,
                      message: 'Please enter a valid postal code.'
                    }
                  }}
              />
              <TextInput
                  name="email"
                  label="Email"
                  required
                  rules={{
                    pattern: {
                      value: emailRegex,
                      message: 'Please enter a valid email.'
                    }
                  }}
              />
              <MaskedInput
                  name="phone"
                  label="Phone"
                  defaultValue=""
                  // onValueChange={handlePhone}
                  thousandSeparator={false}
                  thousandsGroupStyle={""}
                  prefix={""}
                  format={"(###) ###-####"}
                  mask={"_"}
                  rules={{
                    pattern: {
                      value: phoneRegex,
                      message: 'Please enter a valid phone number.'
                    }
                  }}
              />
              <Button type="submit" form="org-form-9" className={styles.bottomSaveButton}>
                Save
              </Button>
            </div>
            </HookForm>
          </AccordionDetails>
        </Accordion>
      <Accordion onChange={(e, expanded) => {setstripeAccordionExpanded(expanded)}} expanded={stripeAccordionExpanded}>
        <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}>
            <h2>Stripe - Payment Processing Integration </h2>
            {stripeSettings?.valid ?
                <>
                  <LinkIcon style={{marginLeft: "10px", color: "green"}}/>
                  <h2 style={{marginLeft: "10px", color: "green"}}>Connected</h2>
                </>
                :
                <>
                  <LinkOffIcon style={{marginLeft: "10px", color: "red"}}/>
                  <h2 style={{marginLeft: "10px", color: "red"}}>Not Connected</h2>
                </>
            }
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {/*<div className={styles.inputsContainer}>*/}

            <DataGridPremium
                autoHeight
                rows={stripeData}
                columns={columns}
                sx={{ flex: 1 }}
                components={{
                  Toolbar: CustomGridToolbar,
                }}
                componentsProps={{ toolbar: { csvOptions: { allColumns: true }}}}
            />
          {/*</div>*/}
        </AccordionDetails>
      </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <h2>goEmerchant - Payment Processing Integration </h2>
              {GEMSettings?.valid ?
                  <>
                    <LinkIcon style={{marginLeft: "10px", color: "green"}}/>
                    <h2 style={{marginLeft: "10px", color: "green"}}>Connected</h2>
                  </>
                  :
                  <>
                    <LinkOffIcon style={{marginLeft: "10px", color: "red"}}/>
                    <h2 style={{marginLeft: "10px", color: "red"}}>Not Connected</h2>
                  </>
              }
            </div>
          </AccordionSummary>
          <HookForm methods={gemFormMethods}
                    onSubmit={onGEMSubmit}
                    className={styles.inputsContainer}
                    formProps={{ id: 'org-form-gem' }}>
          <AccordionDetails>
            <div className={styles.inputsContainer}>
              <TextInput
                name="transactionid"
                required
                label="Transaction Center Id"
              />
              <TextInput name="gatewayid" required label="Gateway Id" />
              <TextInput name="ecommerceid" disabled={true} label="eCommerce Id" />
              {/*<TextInput name="retailid" disabled={true} label="Retail Id" />*/}
              <DateTimeInput name="validationdate" defaultValue={null} disabled={true} label="Validation Date" />
              <DateTimeInput name="lastupdated" disabled={true} label="Last Updated" />
              <Stack direction="row" spacing={2}>
                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    form="org-form-gem"
                    className={styles.bottomSaveButton}>
                  Validate and Save
                </Button>
                <Button variant="contained" className={styles.resetButton} onClick={onResetGEM}>
                  Reset
                </Button>
              </Stack>
            </div>
          </AccordionDetails>
          </HookForm>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <h2>Twilio - Text Messaging Integration</h2>
              {twilioSettings?.valid ?
                  <>
                    <LinkIcon style={{marginLeft: "10px", color: "green"}}/>
                    <h2 style={{marginLeft: "10px", color: "green"}}>Connected</h2>
                  </>
                  :
                  <>
                    <LinkOffIcon style={{marginLeft: "10px", color: "red"}}/>
                    <h2 style={{marginLeft: "10px", color: "red"}}>Not Connected</h2>
                  </>
              }
            </div>
          </AccordionSummary>

          <AccordionDetails>
            <div className={styles.inputsContainer}>
              {twilioSettings?.twiliovisauctionsnapaccount &&
                  <div className={styles.inputsContainerCenterText}>Please contact support@auctionsnap.com if you would like to use your own Twilio account for text messaging.</div>
              }

              <HookForm methods={twilioFormMethods}
                        onSubmit={ontwilioSubmit}
                        className={styles.inputsContainer}
                        formProps={{ id: 'org-form-twilio'}} >
              <MaskedInput
                  name="twiliophone"
                  label="Phone Number"
                  defaultValue=""
                  thousandSeparator={false}
                  thousandsGroupStyle={""}
                  disabled={twilioSettings?.twiliovisauctionsnapaccount}
                  prefix={""}
                  format={"(###) ###-####"}
                  required
                  mask={"_"}
                  rules={{
                    validate: (val) => checkPhoneNumber(val)
                  }}
              />
              <TextInput disabled={true} name="twilioaccountsid" required label="Account SID" />
              <div className={styles.inputButtonContainer}>
                <TextInput
                    name="twilioauthtoken"
                    disabled={twilioSettings?.twiliovisauctionsnapaccount}
                    required
                    label="Auth Token"
                />
              </div>
                <Stack direction="row" spacing={2}>
                  <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={twilioSettings?.twiliovisauctionsnapaccount}
                      form="org-form-twilio"
                      className={styles.bottomSaveButton}>
                    Validate and Save
                  </Button>
                  <Button disabled={twilioSettings?.twiliovisauctionsnapaccount} variant="contained" className={styles.resetButton} onClick={onResetTWILIO}>
                    Reset
                  </Button>
                </Stack>
              </HookForm>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
            <h2>Users</h2>
          </AccordionSummary>
          <AccordionDetails>
            <UsersTable />
          </AccordionDetails>
        </Accordion>
        {/*<Accordion>*/}
        {/*  <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>*/}
        {/*    <h2>Receipt Templates</h2>*/}
        {/*  </AccordionSummary>*/}
        {/*  <AccordionDetails>*/}
        {/*    <RecieptTemplatesTable />*/}
        {/*  </AccordionDetails>*/}
        {/*</Accordion>*/}
    </div>
  )
}

export default OrgSettingsPage
